import RootStore from './RootStore'
import { action, computed, observable } from 'mobx'
import { } from '../models/Interfaces'
import { ReportStore } from './ReportStore'

//todo: remove if possible: this duplicates ClientViewStore
export class IndividualViewStore {
	@observable rootStore: RootStore
	@observable reportStore: ReportStore
	@observable showHeaderMenu: boolean = false

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
	}

	@action public async init() {
		this.reportStore = new ReportStore(this.rootStore)
	}

	@action public onShowHeaderMenu() {
		this.showHeaderMenu = !this.showHeaderMenu
	}
}
